import React from "react";
function MenuItem({ image }) {
    return (
        <div className="artworks">
            <div style={{ backgroundImage: `url(${image})` }}  > </div>

        </div>
    );
}

export default MenuItem;
